const ITEMS = [
  "Positioned for the next role, not the last one",
  "Evidence over adjectives",
  "Target · Align · Substantiate · Position",
  "A credible case, not just a better-looking CV",
  "One narrative across CV & LinkedIn",
  "Quantified achievements",
];

export default function Marquee() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee" className="bg-[#DFFF00] py-8 overflow-hidden">
      <div className="marquee-track items-center">
        {loop.map((t, i) => (
          <div key={i} className="flex items-center gap-16 pr-16">
            <span className="font-serif-accent text-2xl md:text-3xl text-[#0A0A0A] whitespace-nowrap">{t}</span>
            <span className="w-2 h-2 rounded-full bg-[#0A0A0A]" />
          </div>
        ))}
      </div>
    </section>
  );
}
